import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = { class: "flex mt-auto space-x-4" }
const _hoisted_2 = ["disabled"]
const _hoisted_3 = {
  key: 0,
  class: "animate-spin h-4 w-4 mr-2 border-t-2 border-b-2 border-red-400 rounded-full"
}
const _hoisted_4 = ["fill"]
const _hoisted_5 = { key: 2 }
const _hoisted_6 = { key: 3 }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("button", {
      onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$emit('contact-seller'))),
      class: "flex-1 bg-green-600 hover:bg-green-700 text-white py-3 px-4 rounded-md font-medium transition-colors shadow-md"
    }, " Kontaktiraj prodavca "),
    _createElementVNode("button", {
      onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.$emit('toggle-follow'))),
      class: _normalizeClass(["flex items-center justify-center text-white py-3 px-4 rounded-md font-medium transition-colors shadow-md", 
        _ctx.following
          ? 'bg-red-700 hover:bg-red-800 border border-red-600'
          : 'bg-gray-700 hover:bg-gray-600 border border-gray-600 hover:border-red-400'
      ]),
      disabled: _ctx.isLoading
    }, [
      (_ctx.isLoading)
        ? (_openBlock(), _createElementBlock("div", _hoisted_3))
        : (_openBlock(), _createElementBlock("svg", {
            key: 1,
            xmlns: "http://www.w3.org/2000/svg",
            class: _normalizeClass(["h-4 w-4 mr-2", _ctx.following ? 'text-red-400' : 'text-red-400']),
            viewBox: "0 0 24 24",
            stroke: "currentColor",
            fill: _ctx.following ? 'currentColor' : 'none'
          }, _cache[2] || (_cache[2] = [
            _createElementVNode("path", {
              "stroke-linecap": "round",
              "stroke-linejoin": "round",
              "stroke-width": "2",
              d: "M4.318 6.318a4.5 4.5 0 000 6.364L12 20.364l7.682-7.682a4.5 4.5 0 00-6.364-6.364L12 7.636l-1.318-1.318a4.5 4.5 0 00-6.364 0z"
            }, null, -1)
          ]), 10, _hoisted_4)),
      (_ctx.following)
        ? (_openBlock(), _createElementBlock("span", _hoisted_5, "Prati se"))
        : (_openBlock(), _createElementBlock("span", _hoisted_6, "Prati"))
    ], 10, _hoisted_2)
  ]))
}